import React, {useMemo, useState} from 'react';
import {useSelector} from "react-redux";

import MainToolbar from '../MainToolbar';
import SettingsDrawer from "../shared/SettingsDrawer";
import { t } from '../common/LocalizationProvider';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import {formatBoolean, formatBooleanDesable} from '../common/formatter';

import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Switch,
  CssBaseline, Container, useTheme, useMediaQuery,
  alpha
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
  redText: {
    color: "#ff4d4d !important", // Cyber Red
    textShadow: '0 0 8px rgba(255, 77, 77, 0.3)',
  },
  blueTextUsers: {
    color: "#00f2ff !important", // Neon Cyan for child users
    fontWeight: 'bold',
  },
  // Dialog Customization
  dialogPaper: {
    backgroundColor: '#0d161f',
    border: '1px solid rgba(0, 242, 255, 0.3)',
    color: '#ffffff',
    backdropFilter: 'blur(15px)',
  },
  dialogTitle: {
    color: '#00f2ff',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  dialogText: {
    color: 'rgba(255, 255, 255, 0.7)',
  },
  cyberButton: {
    color: '#00f2ff',
    borderColor: 'rgba(0, 242, 255, 0.5)',
  },
  cyberButtonConfirm: {
    backgroundColor: '#00f2ff',
    color: '#000',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#00c8d4',
    }
  },
  switchBase: {
    color: '#444',
    '&$checked': {
      color: '#00f2ff',
    },
    '&$checked + $track': {
      backgroundColor: '#00f2ff',
    },
  },
  checked: {},
  track: {},
}));

const usePageStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const UsersView = ({ updateTimestamp, onMenuClick }) => {
  const classes = useStyles();
  const subadmin = useSelector(state => state.session.user && state.session.user);
  const [items, setItems] = useState([]);
  const [expandedUserId, setExpandedUserId] = useState(null);

  const storedValue = localStorage.getItem('tokenThingwings');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [open, setOpen] = useState(false);
  const [validObj, setValidObj] = useState({id: null, validemail: false, validate: false});
  const [message, setMessage] = useState("error");

  const handleRowClick = (userId) => {
    if (expandedUserId === userId) {
      setExpandedUserId(null);
    } else {
      setExpandedUserId(userId);
    }
  };

  const handleChange = async (id, validate, validemail) => {
    setValidObj({id, validemail, validate})
    setOpen(true)
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleSend = async () => {
    if (validObj.validemail) {
      let validateTemp;
      if (validObj.validate) validateTemp = false;
      else validateTemp = true;
      let url = `/api/users/validateSubadmin`;

      let objects = items;
      let user;
      objects = objects.map((object) => {
        if (object.user.id === validObj.id) {
          user = {...object.user, validate: validateTemp};
          return {...object, user: user};
        }
        return object;
      });

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': 'Bearer ' + storedValue
        },
        body: JSON.stringify(user),
      });

      if (response.ok) {
        let res = await response.json();
        objects = objects.map((object) => {
          if (object.user.id === validObj.id) {
            const updatedUser = {...object.user, validate: res.validate};
            return {...object, user: updatedUser};
          }
          return object;
        });
        setItems(objects);
        setOpenSnackbar(true)
        setMessage("sucsses")
      }
      setOpen(false);
    }
    else
      setOpen(false);
  }

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  function snackbarColor() {
    if (message === "sucsses")
      return "success"
    else
      return "error"
  }

  function messaging() {
    if (message === "sucsses")
      return t("successndrquest")
    else
      return t("errorsndrquest")
  }

  useEffectAsync(async () => {
    const response = await fetch('/api/users');
    if (response.ok) {
      let res = await response.json()
      setItems(res);
    }
  }, [updateTimestamp]);

  const shouldRemove = (item) => {
    return item.user.attributes.hasOwnProperty("shouldRemoved") && item.user.attributes.shouldRemoved;
  };

  const adminUsers = useMemo(() => {
    // const initial = {id: 0, organization: items[0]?.organization || '', password: null, user: subadmin}
    const filtred = subadmin.administrator ? items.filter((item) => !item.user.administrator && item.user.subadmin) : items;
    // return [initial, ...filtred]
    return filtred;
  }, [items, subadmin]);

  const adminUsers1 = useMemo(() => {
    if (subadmin?.administrator) {
      const adminItem = items.find(item => item.user?.administrator);
      const filtered = items.filter(item => !item.user?.administrator);
      return adminItem ? [adminItem, ...filtered] : filtered;
    }
    else
      return items
  }, [items]);

  const childUsers = useMemo(()=> expandedUserId && subadmin.administrator ? items.filter((item) => !item.user.administrator && !item.user.subadmin && item.user.adminid === expandedUserId ) : [],[items, expandedUserId, subadmin]);

  const handleSetMap = async (item) => {
    const url = `/api/users/changeMapType`;
    let updatedUser = item.user;
    updatedUser =  {...updatedUser, map: updatedUser.map === 'googleMap' ? 'osm' : 'googleMap'};
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': 'Bearer ' + storedValue
        },
        body: JSON.stringify(updatedUser),
      });
      if (response.ok) {
        let res = await response.json();
        let usersInObject= items.map((object) => {
          if (object.user.id === res.id) {
            return {...object, user: res};
          }
          return object;
        });
        setItems(usersInObject);
        setOpenSnackbar(true)
        setMessage("sucsses")
      }
    } catch (error) {
      throw error;
    }
  };

  const usersListComponent = (item, isChild) => {
    const textClass = isChild ? classes.blueTextUsers : (shouldRemove(item) ? classes.redText : '');
    return <>
      <TableCell className={classes.columnAction} padding="none">
        <IconButton onClick={(event) => {
          event.stopPropagation();
          onMenuClick(event.currentTarget, item.user.id);
        }}>
          <MoreVertIcon/>
        </IconButton>
      </TableCell>
      <TableCell className={textClass}>{item.user.name} </TableCell>
      <TableCell className={textClass} style={{ opacity: 0.8 }}>{item.user.email}</TableCell>
      {subadmin.administrator && <TableCell className={textClass}>{item.organization}</TableCell>}
      <TableCell className={textClass}>{formatBoolean(item.user, 'administrator')}</TableCell>
      <TableCell className={textClass}>{formatBooleanDesable(item.user, 'disabled')}</TableCell>
      {subadmin.administrator && (
          item.user.validemail ? (
              <TableCell onClick={(e) => e.stopPropagation()}>
                <Switch
                    classes={{
                      switchBase: classes.switchBase,
                      checked: classes.checked,
                      track: classes.track,
                    }}
                    key={item.user.id}
                    checked={item.user.validate}
                    onChange={() => handleChange(item.user.id, item.user.validate, item.user.validemail)}
                    name="checkedA"
                />
              </TableCell>
          ) : (
              <TableCell className={shouldRemove(item) ? classes.redText : ''}>
                {!shouldRemove(item) ? t('waitinEmailValidate') : t('shouldDeleteSubadmin')}
              </TableCell>
          )
      )}
      {subadmin.administrator && (
          <TableCell onClick={(e) => e.stopPropagation()}>
            <Switch
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.checked,
                  track: classes.track,
                }}
                key={item.user.map}
                checked={item.user.map==="googleMap"}
                onChange={() => handleSetMap(item)}
                name="mapType"
            />
          </TableCell>)}
    </>;}

  return (
      <TableContainer className={classes.container}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell + ' ' + classes.columnAction}/>
              <TableCell className={classes.headerCell}>{t('sharedName')}</TableCell>
              <TableCell className={classes.headerCell}>{t('userEmail')}</TableCell>
              {subadmin.administrator && <TableCell className={classes.headerCell}>{t('userOrganization')}</TableCell>}
              <TableCell className={classes.headerCell}>{t('userAdmin')}</TableCell>
              <TableCell className={classes.headerCell}>{t('sharedDisabled')}</TableCell>
              {subadmin.administrator && <TableCell className={classes.headerCell}>{t('validate')}</TableCell>}
              {subadmin.administrator && <TableCell className={classes.headerCell}>GoogleMap</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {adminUsers1.map((item) => (
                <React.Fragment key={item.user.id}>
                  <TableRow className={classes.row} onClick={() => handleRowClick(item.user.id)}>
                    {usersListComponent(item, false)}
                  </TableRow>
                  {childUsers.map((childItem) => (
                      (expandedUserId === item.user.id) && (
                          <TableRow className={classes.row} key={childItem.user.id}>
                            {usersListComponent(childItem, true)}
                          </TableRow>
                      )
                  ))}
                </React.Fragment>
            ))}
          </TableBody>
        </Table>

        <Dialog
            open={open}
            onClose={handleClose}
            classes={{ paper: classes.dialogPaper }}
        >
          <DialogTitle className={classes.dialogTitle}>{t("confirmation")}</DialogTitle>
          <DialogContent>
            <DialogContentText className={classes.dialogText}>
              {t("send message validate")}
            </DialogContentText>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
              <Button className={classes.cyberButton} onClick={handleClose}>
                {t("sharedCancel")}
              </Button>
              <Button className={classes.cyberButtonConfirm} variant='contained' onClick={handleSend}>
                {t("send")}
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} variant="filled" severity={snackbarColor()}>
            {messaging()}
          </Alert>
        </Snackbar>
      </TableContainer>
  );
}

const UsersPage = () => {
  const classes = usePageStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');

  return (
      <div className={classes.settingRoot}>
        <CssBaseline />

        {!isMobile && <div className={classes.appBarWrapper}>
          <MainToolbar/>
        </div>}

        <SettingsDrawer
            hideDrawer={hideDrawer}
            setHideDrawer={setHideDrawer}
            page={'settings'}
        />

        <main className={classes.content}>
          <div className={classes.toolbarSpacer} />

          <Container maxWidth="xl">
            <EditCollectionView
                content={UsersView}
                editPath="/user"
                endpoint="users"
            />
          </Container>
        </main>
      </div>
  );
}

export default UsersPage;